import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import echarts from 'echarts'
import 'video.js/dist/video-js.css'

Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'zIndex':99999,'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.prototype.$echarts = echarts

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  const type = to.meta.type
  // 判断该路由是否需要登录权限
  if (type === 'login') {
    console.log(window.localStorage.getItem('token'))
    var token = window.localStorage.getItem('token');
    if (token) {
      axios.post(
        '/api/check_login', { token:token }
      ).then(function (res) {
        console.log(res)
        var data = res.data;
        if (data.code == '200ok') {
          next()
        }  else {
          next('/login')
        }
      }).catch(function (error) {
        next('/login')
      })
    } else {
      next('/login')
    }
  } else {
    next() // 确保一定要有next()被调用
  }
})

Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({

  router,
  store,

  render: h => h(App)
}).$mount('#app')